module.exports = __webpack_public_path__ + "img/paytm.ab49dbaa.svg";